import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 解决导航栏或者底部导航tabBar中的vue-router在3.0版本以上频繁点击菜单报错的问题。
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'Manager',
    component: () => import('../views/Manager.vue'),
    redirect: '/home',  // 重定向到主页
    children: [
      { path: '403', name: 'NoAuth', meta: { name: '无权限' }, component: () => import('../views/manager/403') },
      { path: 'home', name: 'Home', meta: { name: '系统首页' }, component: () => import('../views/manager/Home') },
      { path: 'admin', name: 'Admin', meta: { name: '管理员信息' }, component: () => import('../views/manager/Admin') },
      { path: 'staff', name: 'Staff', meta: { name: '员工信息' }, component: () => import('../views/manager/Staff') },
      { path: 'staffPerson', name: 'StaffPerson', meta: { name: '员工个人信息' }, component: () => import('../views/manager/StaffPerson') },
      { path: 'adminPerson', name: 'AdminPerson', meta: { name: '个人信息' }, component: () => import('../views/manager/AdminPerson') },
      { path: 'password', name: 'Password', meta: { name: '修改密码' }, component: () => import('../views/manager/Password') },
      { path: 'notice', name: 'Notice', meta: { name: '公告信息' }, component: () => import('../views/manager/Notice') },
      { path: 'department', name: 'Department', meta: { name: '部门信息' }, component: () => import('../views/manager/Department') },
      { path: 'category', name: 'Category', meta: { name: '部门信息' }, component: () => import('../views/manager/Category') },
      { path: 'assets', name: 'Assets', meta: { name: '固定资产' }, component: () => import('../views/manager/Assets') },
      { path: 'assetsReceive', name: 'AssetsReceive', meta: { name: '资产领用' }, component: () => import('../views/manager/AssetsReceive') },
      { path: 'assetsIn', name: 'AssetsIn', meta: { name: '资产入库' }, component: () => import('../views/manager/AssetsIn') },
      { path: 'staffAssets', name: 'StaffAssets', meta: { name: '资产入库' }, component: () => import('../views/manager/StaffAssets') },
      { path: 'assetsRepair', name: 'AssetsRepair', meta: { name: '资产入库' }, component: () => import('../views/manager/AssetsRepair') },
      { path: 'integration', name: 'Integration', meta: { name: '集成管理' }, component: () => import('../views/manager/Integration') },

    ]
  },
  {
    path: '/front',
    name: 'Front',
    component: () => import('../views/Front.vue'),
    children: [
      { path: 'home', name: 'Home', meta: { name: '系统首页' }, component: () => import('../views/front/Home') },
      { path: 'person', name: 'Person', meta: { name: '个人信息' }, component: () => import('../views/front/Person') },
    ]
  },
  { path: '/login', name: 'Login', meta: { name: '登录' }, component: () => import('../views/Login.vue') },
  { path: '/register', name: 'Register', meta: { name: '注册' }, component: () => import('../views/Register.vue') },
  { path: '/wechat-callback', name: 'WechatCallback', meta: { name: '企业微信回调' }, component: () => import('../views/WechatCallback.vue') },

  // ===== 移动端（独立路由组，与 PC 的 Manager/Front 布局完全隔离，互不打扰） =====
  {
    path: '/m',
    name: 'Mobile',
    component: () => import('../views/mobile/MobileLayout.vue'),
    redirect: '/m/home',
    children: [
      { path: 'login', name: 'MobileLogin', meta: { name: '登录' }, component: () => import('../views/mobile/Login.vue') },
      { path: 'home', name: 'MobileHome', meta: { name: '工作台' }, component: () => import('../views/mobile/Home.vue') },
      { path: 'asset', name: 'MobileAsset', meta: { name: '资产查询' }, component: () => import('../views/mobile/Asset.vue') },
      { path: 'inventory', name: 'MobileInventory', meta: { name: '资产盘点' }, component: () => import('../views/mobile/Inventory.vue') },
      { path: 'apply', name: 'MobileApply', meta: { name: '申请' }, component: () => import('../views/mobile/Apply.vue') },
      { path: 'myreceive', name: 'MobileMyReceive', meta: { name: '我领用的资产' }, component: () => import('../views/mobile/MyReceive.vue') },
      { path: 'myrepair', name: 'MobileMyRepair', meta: { name: '我报修的记录' }, component: () => import('../views/mobile/MyRepair.vue') },
      { path: 'notice', name: 'MobileNotice', meta: { name: '公司公告' }, component: () => import('../views/mobile/Notice.vue') },
      { path: 'myinventory', name: 'MobileMyInventory', meta: { name: '我的盘点任务' }, component: () => import('../views/mobile/MyInventory.vue') },
      { path: 'return', name: 'MobileReturnApply', meta: { name: '资产归还申请' }, component: () => import('../views/mobile/ReturnApply.vue') },
      { path: 'mine', name: 'MobileMine', meta: { name: '我的' }, component: () => import('../views/mobile/Mine.vue') },
    ]
  },

  { path: '*', name: 'NotFound', meta: { name: '无法访问' }, component: () => import('../views/404.vue') },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 移动端 / PC 自动分流：二者通过不同路由组隔离，不混用
function isMobileDevice() {
  const f = new URLSearchParams(window.location.search).get('mobile')
  if (f === '1') return true
  if (f === '0') return false
  return /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent)
}

// 这些路径不做设备分流：企业微信回调需原样加载回调页处理 code
const BYPASS_PATHS = ['/wechat-callback']

// 注意：必须在 new VueRouter() 之后再注册守卫。
// 否则 router 处于 TDZ（暂时性死区），模块加载即抛 ReferenceError，导致整个 SPA 白屏。
router.beforeEach((to, from, next) => {
  // 回调页等特殊路径直接放行，避免被移动/PC 分流改写而中断登录
  if (BYPASS_PATHS.includes(to.path)) return next()

  const mobile = isMobileDevice()
  const inMobile = to.path.startsWith('/m')
  // 移动端内页需要登录态，未登录自动跳移动端登录
  if (inMobile && to.path !== '/m/login') {
    const user = JSON.parse(localStorage.getItem('xm-user') || '{}')
    if (!user.role) return next('/m/login')
  }
  if (mobile && !inMobile) {
    // 移动设备访问 PC 地址 → 进入移动端首页（登录页单独映射）
    if (to.path === '/login') return next('/m/login')
    return next('/m/home')
  }
  if (!mobile && inMobile) {
    // PC 访问移动端地址 → 回到 PC 首页
    return next('/home')
  }
  next()
})

// 注：不需要前台的项目，可以注释掉该路由守卫
// 路由守卫
// router.beforeEach((to ,from, next) => {
//   let user = JSON.parse(localStorage.getItem("xm-user") || '{}');
//   if (to.path === '/') {
//     if (user.role) {
//       if (user.role === 'USER') {
//         next('/front/home')
//       } else {
//         next('/home')
//       }
//     } else {
//       next('/login')
//     }
//   } else {
//     next()
//   }
// })

export default router
